const chunkFailedMessage = /Loading chunk [\d]+ failed/;
const importModuleScriptFailedMessage = 'Importing a module script failed';
const dynamicImportFailedMessage = 'Failed to fetch dynamically imported module';

export function isChunkLoadError(error?: unknown) {
  if (!(error instanceof Error)) {
    return false;
  }

  const isErrorNameChunkLoadError = error?.name === 'ChunkLoadError';
  const isErrorMessageChunkLoadFailed =
    error?.message &&
    (chunkFailedMessage.test(error.message) ||
      error.message.includes(dynamicImportFailedMessage) ||
      error.message.includes(importModuleScriptFailedMessage));

  return isErrorNameChunkLoadError || isErrorMessageChunkLoadFailed;
}
